import { maxWidth, noTouch } from '@/assets/styles/mixins.css';
import styled from 'styled-components';
import vars from '@/assets/styles/vars';
import { loadableStyles } from '@/assets/styles/global.css';

const Specialist = styled.div`
  --common-transition-time: 0.3s;
  --image-height: 303px;

  position: relative;
  overflow: hidden;
  z-index: 0;
  transition: z-index 0s var(--common-transition-time);
  
  ${maxWidth(vars.breakpoints.mTablet)`
    --image-height: 320px;
  `}

  ${loadableStyles}

  ${noTouch()`
    &:hover {
      z-index: 1;
      transition: z-index 0s;
    }
  `}
`;

Specialist.Bg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  background: #fff;
  transition: transform var(--common-transition-time) ease-in;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: var(--image-height);
    background-color: var(--color-bg-accent);
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity var(--common-transition-time) ease-in;
  }

  ${noTouch()`
    ${Specialist}:hover & {
      transition: transform var(--common-transition-time) ease-in;

      &:after {
        opacity: 1;
      }
    }
  `}
`;

Specialist.Circle = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 80%;
  height: var(--image-height);
  max-width: 320px;
  overflow: hidden;

  &::after {
    content: '';
    display: block;
    width: 100%;
    padding-top: 100%;
    border-radius: 50%;
    background: linear-gradient(222.24deg, #f3f4f7 25.72%, #f9fafb 84.9%);
    box-shadow: 0px 0px 32px rgba(0, 0, 0, 0.02), 0px 0px 4px rgba(0, 0, 0, 0.03);
    opacity: 0;
    transform: translate(20%, -30%);
    transition: opacity var(--common-transition-time) ease-out, transform var(--common-transition-time) ease-out;
  }

  ${noTouch()`
    ${Specialist}:hover & {
      &::after {
        opacity: 1;
      transform: translate(8%, -30%);
      }
    }
  `}

  ${maxWidth(vars.breakpoints.tablet)`
    display: none;
  `}
`;

Specialist.Img = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
  transition: transform var(--common-transition-time) ease-in;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: var(--image-height);
  }

  img {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: 100%;
    height: auto;
    max-height: calc(100% - 15px);
    object-fit: contain;
    transition: transform var(--common-transition-time) ease-in;
  }

  ${noTouch()`
    ${Specialist}:hover & img {
      transform: scale(1.15);
    }
  `}
`;

Specialist.Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 25px 0 0;

  ${maxWidth(vars.breakpoints.tablet)`
    padding: 15px 0 0;
  `}
`;

Specialist.Title = styled.h3`
  --title-font-size: 24px;
  --title-line-height: 1.2;

  font-weight: normal;
  font-size: var(--title-font-size);
  line-height: var(--title-line-height);
  color: var(--color-decor);
  white-space: pre-wrap;
`;

Specialist.Qualification = styled.div`
  margin-top: 10px;
  font-weight: normal;
  font-size: 18px;
  line-height: 1.2;
  color: #acacac;
`;

Specialist.Arrow = styled.div`
  position: absolute;
  top: calc(var(--image-height) + 32px);
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-decor);
  opacity: 0;
  transform: translateX(-6px);
  transition: opacity var(--common-transition-time) ease-in, transform var(--common-transition-time) ease-in;

  svg {
    vertical-align: middle;
    width: 16px;
    height: 13px;
  }

  ${noTouch()`
    ${Specialist}:hover & {
      opacity: 1;
      transform: none;
    }
  `}

  ${maxWidth(vars.breakpoints.tablet)`
    top: calc(var(--image-height) + 25px);
    width: auto;
    height: auto;
    background: 0 0;
    color: var(--color-decor);
    opacity: 1;
    transform: none;
    transition: transform var(--common-transition-time) ease-in;

    ${noTouch()`
      ${Specialist}:hover & {
        transform: translateY(5px);
      }
    `}
  `}
`;

Specialist.Link = styled.a`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

export default Specialist;
